// 5
export const GYAKORLAT_INFORMACIOK_OPTIONS = {
    hu: [
    { value: 'atfogo', label: 'Átfogó, könnyen elérhető információk' },
    { value: 'megfelelo', label: 'Megfelelő, de fejleszthető információk' },
    { value: 'reszleges', label: 'Részleges információk' },
    { value: 'hianyos', label: 'Hiányos információk' },
    { value: 'nincs', label: 'Nincs rendszerezett tájékoztatás' } 
    ],
    en: [
    { value: 'atfogo', label: 'Comprehensive and easily accessible information' },
    { value: 'megfelelo', label: 'Adequate information, with scope for further development' },
    { value: 'reszleges', label: 'Partial information available' },
    { value: 'hianyos', label: 'Incomplete information' },
    { value: 'nincs', label: 'No structured information available' } 
    ]
};

export const PARTNEREK_SZAMA_OPTIONS = {
    hu: [
    { value: 'egy_ot', label: '1-5 partner' },
    { value: 'hat_tiz', label: '6-10 partner' },
    { value: 'tizenegy_husz', label: '11-20 partner' },
    { value: 'huszonegy_otven', label: '21-50 partner' },
    { value: 'otven_plusz', label: '50+ partner' }
    ],
    en: [
    { value: 'egy_ot', label: '1-5 partners' },
    { value: 'hat_tiz', label: '6-10 partners' },
    { value: 'tizenegy_husz', label: '11-20 partners' },
    { value: 'huszonegy_otven', label: '21-50 partners' },
    { value: 'otven_plusz', label: '50+ partners' }
    ]
};

export const PARTNEREK_TIPUSA_OPTIONS = {
    hu: [
    { value: 'multinacionalis', label: 'Multinacionális nagyvállalatok' },
    { value: 'hazai', label: 'Hazai nagyvállalatok' },
    { value: 'kozep', label: 'Középvállalatok' },
    { value: 'kkv', label: 'KKV-k' },
    { value: 'startup', label: 'Startup cégek' },
    { value: 'allami', label: 'Állami/önkormányzati szervezetek' },
    { value: 'non_profit', label: 'Non-profit szervezetek' },
    { value: 'kutatointezetek', label: 'Kutatóintézetek' },
    { value: 'kulfoldi', label: 'Külföldi partnerek' },
    { value: 'egyeb', label: 'Egyéb:' }
    ],
    en: [
    { value: 'multinacionalis', label: 'Multinational corporations' },
    { value: 'hazai', label: 'Domestic large enterprises' },
    { value: 'kozep', label: 'Medium-sized enterprises' },
    { value: 'kkv', label: 'SMEs' },
    { value: 'startup', label: 'Start-up companies' },
    { value: 'allami', label: 'Governmental / municipal organizations' },
    { value: 'non_profit', label: 'Non-profit organizations' },
    { value: 'kutatointezetek', label: 'Research institutes' },
    { value: 'kulfoldi', label: 'International partners' },
    { value: 'egyeb', label: 'Other:' }
    ]
};

export const ALUMNI_KAPCSOLAT_OPTIONS = {
    hu: [
    { value: 'rendszeres', label: 'Igen, rendszeres és strukturált alumni kapcsolattartás' },
    { value: 'alkalomszeru', label: 'Igen, alkalomszerű alumni bevonás' },
    { value: 'tervezett', label: 'Tervezett, de még nem valósult meg' },
    { value: 'nem_volt', label: 'Nem volt alumni kapcsolattartás' }
    ],
    en: [
    { value: 'rendszeres', label: 'Yes, regular and structured alumni engagement' },
    { value: 'alkalomszeru', label: 'Yes, occasional involvement of alumni' },
    { value: 'tervezett', label: 'Planned but not yet implemented' },
    { value: 'nem_volt', label: 'No alumni engagement' }
    ] 
};

export const VALLALATI_KAPCSOLAT_OPTIONS = {
    hu: [
    { value: 'aktiv', label: 'Igen, aktív vállalati kapcsolatépítés zajlott' },
    { value: 'meglevo', label: 'Igen, meglévő kapcsolatok karbantartása' },
    { value: 'reszleges', label: 'Részleges kapcsolatfelvétel' },
    { value: 'nagyon_volt', label: 'Nem volt jelentős kapcsolatfelvétel' }
    ],
    en: [
    { value: 'aktiv', label: 'Yes, active development of corporate partnerships' },
    { value: 'meglevo', label: 'Yes, maintenance of existing partnerships' },
    { value: 'reszleges', label: 'Partial engagement' },
    { value: 'nagyon_volt', label: 'No significant corporate engagement' }
    ]
};

export const SZAKMAI_SZERVEZET_OPTIONS = {
    hu: [
    { value: 'rendszeres', label: 'Igen, rendszeres együttműködés' },
    { value: 'alkalmi', label: 'Igen, alkalmi kapcsolat' },
    { value: 'tervezett', label: 'Tervezett' },
    { value: 'nem_volt', label: 'Nem volt kapcsolat' }
    ],
    en: [
    { value: 'rendszeres', label: 'Yes, regural cooperation' },
    { value: 'alkalmi', label: 'Yes, occasional engagement' },
    { value: 'tervezett', label: 'Under consideration' },
    { value: 'nem_volt', label: 'No engagement' }
    ]
};